import { createSlice } from '@reduxjs/toolkit';
import { changeComplaintStatus } from './actions';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  hasLoaded: false,
  updatingId: null,
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to update complaint status';

const changeStatusSlice = createSlice({
  name: 'changeStatus',
  initialState,
  reducers: {
    resetChangeStatusState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeComplaintStatus.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.hasLoaded = false;
        state.updatingId = action.meta.arg?.id ?? null;
      })
      .addCase(changeComplaintStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasLoaded = true;
        state.updatingId = null;
        state.data = action.payload?.data ?? action.payload;
      })
      .addCase(changeComplaintStatus.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isLoading = false;
        state.hasLoaded = true;
        state.updatingId = null;
        state.error = errorMessage(action);
      });
  },
});

export const { resetChangeStatusState } = changeStatusSlice.actions;
export default changeStatusSlice.reducer;
